module.exports = __webpack_public_path__ + "img/1778573835496-INFOGRAFIS EPSS 1.png.61ed82e3.webp";